var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconHidraulica = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 48,
  height: 48,
  viewBox: "0 0 48 48",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1.40625 8.625C0.629151 8.625 0 9.25415 0 10.0312V24.0938C0 24.8708 0.629151 25.5 1.40625 25.5C3.73242 25.5 5.625 23.6074 5.625 21.2812V12.8438C5.625 10.5176 3.73242 8.625 1.40625 8.625Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M46.5938 28.3125H45.1875V21.2812C45.1875 15.8533 40.7717 11.4375 35.3438 11.4375H28.2188V10.0312C28.2188 9.24353 27.6002 8.625 26.8125 8.625H15.5625C14.7748 8.625 14.1562 9.24353 14.1562 10.0312V11.4375H8.29688C8.3811 11.8876 8.4375 12.3655 8.4375 12.8438V21.2812C8.4375 21.7595 8.3811 22.2374 8.29688 22.6875H14.8876C16.4905 24.4592 18.7969 25.5 21.1875 25.5C23.5781 25.5 25.8845 24.4592 27.4874 22.6875H33.9375V28.3125H32.5312C31.7542 28.3125 31.125 28.9417 31.125 29.7188C31.125 30.4958 31.7542 31.125 32.5312 31.125H46.5938C47.3708 31.125 48 30.4958 48 29.7188C48 28.9417 47.3708 28.3125 46.5938 28.3125Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M39.5625 48C42.6647 48 45.1875 45.4772 45.1875 42.375C45.1875 40.2297 42.3625 35.179 39.5625 31.125C36.7625 35.179 33.9375 40.2297 33.9375 42.375C33.9375 45.4772 36.4603 48 39.5625 48Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M12.75 2.8125H16.9688V5.8125H25.4062V2.8125H29.625C30.4021 2.8125 31.0312 2.18335 31.0312 1.40625C31.0312 0.629151 30.4021 0 29.625 0H12.75C11.9729 0 11.3438 0.629151 11.3438 1.40625C11.3438 2.18335 11.9729 2.8125 12.75 2.8125Z"
})));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconHidraulica, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_hidraulica.c53919ec.svg";
export { ForwardRef as ReactComponent };